import React, { SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import { RouteComponentProps, Link as RouterLink } from 'react-router-dom';
// Components
import App from '../../components/app';
// import ErrorMessage from '../../components/error-message';
import MainLoading from '../../components/main-loading';
import { getMenu, Logo } from '../../components/menu-drawer/menu-drawer';
import { TooltipButton } from '../../components/tooltip-button';
import ChristmasTree from './ChristmasTree';
// Modules
import { selectors as pendingSelectors } from '../../redux/reducers/pendingOperations';
import { actions as homeActions, selectors as homeSelectors } from '../../redux/reducers/home';
import { actions as riderActions } from '../../redux/reducers/riders';
// Ressources
import { HeartFillIcon } from '../../assets/images';
import withGlobalStyles from '../../utils/global-styles';
import { useLifecycles } from '../../utils/hookUtils';
import { Favorite } from '../../utils/userDataUtils';
import UserUtils from '../../utils/userUtils';
import styles from './home-style';
import { RiderReserver } from '../../redux/reducers/api-types';
import FormUtils from '../../utils/forms';

interface HomePageProps extends WithTranslation, WithStyles, RouteComponentProps {
    loadMenus: () => any;
    toggleFavorite: (path: string, name?: string, removeIfExist?: boolean) => any;
    clearError: () => void;
    setFoundRider: (rider: RiderReserver) => void;
    globalClasses: any;
    favorites: Favorite[];
    menusLoaded: boolean;
    redirect: any;
    isLoading: boolean;
}

const HomePage = (props: HomePageProps): JSX.Element => {
    const { t, history, classes, globalClasses, favorites, menusLoaded, isLoading } = props;
    const menu = getMenu(t);
    const user = UserUtils.getUser();
    const impersonate = UserUtils.getImpersonateInfos();

    useLifecycles(
        () => {
            props.loadMenus();
        },
        () => {
            props.clearError();
        },
    );

    React.useEffect(() => {
        if (menusLoaded && impersonate?.url) {
            UserUtils.removeImpersonateInfos();
            if (impersonate?.rider) {
                props.setFoundRider(impersonate.rider);
            }
            const pathname = new URL(impersonate.url).pathname;
            history.push(pathname);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menusLoaded, impersonate]);

    const handleRemoveFavorite =
        (key: string) =>
        (e: SyntheticEvent): void => {
            e.stopPropagation();
            e.preventDefault();
            props.toggleFavorite(key);
        };

    function handleAddFavorite(e: SyntheticEvent) {
        e.preventDefault();
        const fields = FormUtils.getFields(e.target);

        props.toggleFavorite(fields.favs, '', false);
    }

    return (
        <App
            noFav
            disableBreadcrumb
            header={{
                title: t('title', { name: user?.user?.firstname }),
                subtitle: t('description'),
            }}
        >
            <div className={globalClasses.contentSpacing}>
                {isLoading && <MainLoading />}
                {/* <ErrorMessage payload={redirect.error} /> */}
                {/* Everything below waits for `menus`: the add/remove actions rewrite the whole
                    key, so offering them before we know what is stored would wipe it. */}
                {menusLoaded && favorites.length === 0 && (
                    <>
                        {t('favorite_hint')}
                        <br />
                        <br />
                    </>
                )}
                {menusLoaded && (
                    <>
                        <form onSubmit={handleAddFavorite}>
                            <Select
                                native
                                id={`favs`}
                                name={`favs`}
                                defaultValue={''}
                                className={classes.stateSelector}
                            >
                                {menu.map((m) => {
                                    if (m.to) {
                                        if (m.to === '/') {
                                            return null;
                                        }
                                        return (
                                            <option key={m.label} value={m.to}>
                                                {m.label}
                                            </option>
                                        );
                                    } else {
                                        return (
                                            <optgroup key={m.label} label={m.label}>
                                                {m.items.map((sub) => {
                                                    return sub.subItems.map((subItem) => {
                                                        return (
                                                            <option key={subItem.label} value={subItem.to}>
                                                                {subItem.label}
                                                            </option>
                                                        );
                                                    });
                                                })}
                                            </optgroup>
                                        );
                                    }
                                })}
                            </Select>
                            <Button type="submit" variant="contained" style={{ marginLeft: 12 }}>
                                {t('common:add')}
                            </Button>
                        </form>
                        <br />
                    </>
                )}
                {menusLoaded && favorites.length > 0 && (
                    <div className={classes.cards}>
                        {favorites.map((f, index) => {
                            let item = null;

                            dance: for (const m of menu) {
                                if (m.to === f.to || (m.to && m.to !== '/' && f.to && f.to.startsWith(m.to))) {
                                    item = m;
                                    break;
                                } else if (m.items) {
                                    for (const sm of m.items) {
                                        for (const smi of sm.subItems) {
                                            if (
                                                smi.to === f.to ||
                                                (smi.to && smi.to !== '/' && f.to && f.to.startsWith(smi.to))
                                            ) {
                                                item = {
                                                    ...smi,
                                                    color: m.color,
                                                };
                                                break dance;
                                            }
                                        }
                                    }
                                }
                            }

                            if (!item) {
                                return null;
                            }

                            return (
                                <div key={index} className={classes.card}>
                                    <Button component={RouterLink} to={f.to} className={classes.flex}>
                                        <div className={classes.cardContent}>
                                            <div className={classes.flex}>
                                                <span className={classes.flex} />
                                                <TooltipButton
                                                    title={t('common:delete')}
                                                    icon={Logo(HeartFillIcon, { marginRight: 0 })}
                                                    onClick={handleRemoveFavorite(f.to)}
                                                />
                                            </div>
                                            <div className={classes.iconAndText}>
                                                {item.customIcon ? (
                                                    Logo(item.customIcon, { marginRight: 10 }, 50)
                                                ) : (
                                                    <Icon className={classes.icon} fontSize="large">
                                                        {item.icon}
                                                    </Icon>
                                                )}
                                                <div className={classes.cardText}>
                                                    <div className={globalClasses.centerVertical}>
                                                        {item.label}
                                                        <div
                                                            className={classes.colorBuble}
                                                            style={{ backgroundColor: item.color }}
                                                        />
                                                    </div>
                                                    <div className={classes.cardSubtitle}>{f?.name}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                            );
                        })}
                    </div>
                )}

                <ChristmasTree />
            </div>
        </App>
    );
};

const HomeWithStyle = withGlobalStyles(withStyles(styles)(HomePage));
const HomeWithTranslation = withTranslation(['home', 'menu', 'common'])(HomeWithStyle);

const mapStateToProps = (state) => ({
    favorites: homeSelectors.favoritesList(state),
    menusLoaded: homeSelectors.menusLoaded(state),
    redirect: homeSelectors.redirect(state),
    isLoading: pendingSelectors.isGettigUserStorage(state),
});

const mapDispatchToProps = {
    loadMenus: homeActions.loadMenus,
    toggleFavorite: homeActions.toggleFavorite,
    clearError: homeActions.clearError,
    setFoundRider: riderActions.setFoundRider,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeWithTranslation);
